import React, { useState } from "react";
import { Table, TableColumn } from "../../components/table";
import SearchField from "../../components/textfield/searchField";
import { useHistory } from "react-router-dom";
import HeaderBar from "../../components/header/headerBar";
import Icon from "@mdi/react";
import { mdiEyeOutline, mdiPrinter } from "@mdi/js";
import MainButton from "../../components/button/mainButton";
import SearchFieldSelect from "../../components/textfield/searchFieldSelect";

const JobCost = () => {
  const [show, setShow] = useState(false);
  const history = useHistory();
  const columns = [
    {
      title: "",
    },
    {
      title: "เลขที่ใบยา",
    },
    {
      title: "CN",
    },
    {
      title: "Name",
    },
    {
      title: "Treatment",
    },
    {
      title: "ใช้/ทั้งหมด",
      align: "center",
    },
    {
      title: "Date",
      align: "center",
    },
    {
      title: "",
      align: "",
    },
  ];

  const data = [
    {
      decalationno: "VN EK - 29013",
      cn: "PRP",
      name: "Ms. Alice Watts",
      treatment: "เปิดวงเงิน",
      total: "10,000/50,000",
      date: "18-12-2564",
      status: "Y",
    },
    {
      decalationno: "VN EK - 29013",
      name: "Ms. Alice Watts",
      cn: "Hair Transplant FUE",
      treatment: "Unit",
      total: "1/2",
      date: "18-12-2564",
      status: "",
    },
    {
      decalationno: "VN EK - 29013",
      name: "Ms. Alice Watts",
      cn: "Botox",
      treatment: "Unit",
      total: "300/300",
      date: "18-12-2564",
      status: "",
    },
    {
      decalationno: "VN EK - 29013",
      cn: "Dual Yellow 5 Times",
      name: "Ms. Alice Watts",
      treatment: "รายครั้ง",
      total: "4/5",
      date: "18-12-2564",
      status: "",
    },
  ];

  const option = [
    { value: "", name: "ค้นหาโดย" },
    { value: "1", name: "CN" },
    { value: "2", name: "Name" },
    { value: "3", name: "Mobile No." },
  ];

  const onChangeOtherd = (index: string) => {
    console.log("index xxx => ", index);
  };

  return (
    <div>
      <HeaderBar title="JOB COST" />
      <div style={{ padding: "0px 40px" }}>
        <SearchFieldSelect
          placeholder="Search for customer (CN, Name, Mobile No.)"
          color="#FFFFFF"
          // option={}
          onChangeOtherd={onChangeOtherd}
        />
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {data.map((item, index) => (
              <tr
                key={index}
                // onClick={() => history.push(`/usedcourse/${item.SO}`)}
                style={{ cursor: "pointer" }}
              >
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn width="10%">{item.decalationno}</TableColumn>
                <TableColumn width="10%">{item.name}</TableColumn>
                <TableColumn width="20%">{item.cn}</TableColumn>
                <TableColumn width="7%" align="center">
                  {item.treatment}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {item.total}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {item.date}
                </TableColumn>
                <TableColumn width="10%" align="center" padding="0px">
                  <div className="EyebtnTitle">
                    <div
                      style={{
                        display: item.status !== "Y" ? "none" : "block",
                      }}
                      onClick={() =>
                        history.push(`/jobcost/view/${index}/jobcost`)
                      }
                    >
                      <div className="eyeBtn">
                        <Icon path={mdiEyeOutline} size="20" color="#FFFFFF" />
                      </div>
                    </div>
                    <div>&nbsp;</div>
                    <div
                      style={{
                        display: item.status !== "Y" ? "none" : "block",
                      }}
                      onClick={() => history.push(`/jobcost/view/${index}`)}
                    >
                      <div className="pBtn">
                        <Icon path={mdiPrinter} size="20" color="#FFFFFF" />
                      </div>
                    </div>
                    <div
                      style={{
                        display: item.status === "Y" ? "none" : "block",
                      }}
                    >
                      <MainButton
                        title="Job Cost"
                        width="100px"
                        height="35px"
                        onClick={() =>
                          history.push(`/jobcost/list/${index}/view`)
                        }
                      ></MainButton>
                    </div>
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default JobCost;
